import { ActionTree, ActionContext } from "vuex";
import { State } from "./state";
import { Mutations, AuthMutationTypes } from "./mutations";
import { RootState } from "@/store";
// import { SingService } from '@/api/sing'
import { SigninParams } from "@/services/sign";
import $API from "@/services";
import { ISignInfo } from "@/models/account";
import router from "@/router";

export enum AuthActionTypes {
  GET_TOKEN = "GET_TOKEN",
  GET_ACCOUNT_INFO = "GET_ACCOUNT_INFO",
  SIGNOUT = "SIGNOUT",
}

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload?: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, "commit">;

export interface Actions {
  [AuthActionTypes.GET_TOKEN](
    { commit }: AugmentedActionContext,
    payload: SigninParams | null,
  ): Promise<void | string>;
  [AuthActionTypes.GET_ACCOUNT_INFO]({ commit }: AugmentedActionContext): Promise<void>;
  [AuthActionTypes.SIGNOUT]({ commit }: AugmentedActionContext): Promise<void>;
}

export const actions: ActionTree<State, RootState> & Actions = {
  async [AuthActionTypes.GET_TOKEN]({ commit }, data) {
    // const signinParam:SigninParams = {email:'aa', password:'bb'}
    try {
      const resp: ISignInfo | string = await $API.SignService.signin(data);
      console.log(resp, "AuthActionTypes.GET_TOKEN.resp");
      if (typeof resp === "string") {
        commit(AuthMutationTypes.SET_TOKEN, resp as string);
      } else {
        commit(AuthMutationTypes.SET_TOKEN, resp.accessToken);
      }
    } catch (ex) {
      if (typeof ex === "string") {
        throw ex;
      } else {
        console.log(ex, "AuthActionTypes.GET_TOKEN.ex");
        return (ex as any)?.ResultData;
      }
    }

    // const { data } = res;
    // if (data.Exception === ExceptionMessages.FAILED) {
    //   return data.ResultData as string;
    // } else commit(AuthMutationTypes.SET_TOKEN, res);
  },
  async [AuthActionTypes.GET_ACCOUNT_INFO]({ commit }) {
    const accountInfo = await $API.AccountsService.getAccountInfo();
    //console.log(res, 'GET_ACCOUNT_INFO.res');
    commit(AuthMutationTypes.SET_INFO, accountInfo);
  },
  async [AuthActionTypes.SIGNOUT]({ commit }) {
    try {
      const success = await $API.SignService.signout();
      if (success) {
        router.push(process.env.BASE_URL);
      } else {
        console.warn(success, "signout failed.");
      }
      commit(AuthMutationTypes.CLEAR_TOKEN);
    } catch (ex) {
      console.warn(ex);
    }
  },
};
